//global.link = "https://localhost:44361/";
global.link = "https://insight2-server.azurewebsites.net/";
//global.endpoint= "https://localhost:44361/api/dashboard";
global.endpoint= "https://insight2-server.azurewebsites.net/api/dashboard";
//global.appLink = "http://localhost:3000/";
global.appLink = "https://insight2-dashboards.azurewebsites.net/";
global.showpanel =  false;